<template>
  <div class="block-datos-resumen cl">
    <div>
      <h3 class="title">Aseguradora anterior</h3>

      <dl class="contenido">
        <dt>Aseguradora:</dt>
        <dd>{{ resumen.aseguradora }}</dd>
        <dt>Años asegurado:</dt>
        <dd>{{ resumen.anyosAseguradora }}</dd>
        <dt>Número partes:</dt>
        <dd>{{ resumen.numPartes }}</dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  store: ["step"],

  props: {
    resumen: {
      type: Object
    }
  }
};
</script>

<style></style>
